import React, { useState } from 'react';
import moment from 'moment';

const TYPE_LABELS = {
    root:           'Root / Acesso privilegiado',
    hook:           'Hook / Instrumentação',
    rat:            'Trojan de Acesso Remoto',
    remote_access:  'Acesso Remoto',
    banking_trojan: 'Trojan Bancário',
    cloaker:        'Ocultador de Apps',
    cloning:        'Clonagem de Apps',
    fake_gps:       'GPS Falso',
    vpn:            'VPN',
    screen_recorder:'Gravador de Tela',
    virtual_camera: 'Câmera Virtual',
};

function formatAbsDate(dateStr) {
    if (!dateStr) return '–';
    const m = moment(dateStr);
    return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : '–';
}

function buildInstallMap(installedApps) {
    const map = new Map();
    (installedApps || []).forEach(app => {
        if (app.package_name) map.set(app.package_name, app);
    });
    return map;
}

function SevIcon({ sev }) {
    if (sev === 'high') {
        return (
            <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ flex: 'none' }}>
                <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM11,7a1,1,0,0,1,2,0v6a1,1,0,0,1-2,0Zm1,12a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,19Z" fill="#dc2626"/>
            </svg>
        );
    }
    if (sev === 'medium') {
        return (
            <svg width="20" height="20" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" style={{ flex: 'none' }}>
                <path d="M30.555 25.219l-12.519-21.436c-1.044-1.044-2.738-1.044-3.782 0l-12.52 21.436c-1.044 1.043-1.044 2.736 0 3.781h28.82c1.046-1.045 1.046-2.738 0.001-3.781zM14.992 11.478c0-0.829 0.672-1.5 1.5-1.5s1.5 0.671 1.5 1.5v7c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-7zM16.501 24.986c-0.828 0-1.5-0.67-1.5-1.5 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.83-0.672 1.5-1.5 1.5z" fill="#d97706"/>
            </svg>
        );
    }
    return (
        <svg width="20" height="20" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg" style={{ flex: 'none' }}>
            <g>
                <path d="M26.7,42.8c0.8,0,1.5,0.7,1.5,1.5v3.2c0,0.8-0.7,1.5-1.5,1.5h-3.2c-0.8,0-1.5-0.7-1.5-1.5v-3.2c0-0.8,0.7-1.5,1.5-1.5H26.7z" fill="#2563eb"/>
                <path d="M28.2,35.1c0-2.1,1.3-4,3.1-4.8h0.1c5.2-2.1,8.8-7.2,8.8-13.2c0-7.8-6.4-14.2-14.2-14.2c-7.2,0-13.2,5.3-14.2,12.2v0.1c-0.1,0.9,0.6,1.6,1.5,1.6h3.2c0.8,0,1.4-0.5,1.5-1.1v-0.2c0.7-3.7,4-6.5,7.9-6.5c4.5,0,8.1,3.6,8.1,8.1c0,2.1-0.8,4-2.1,5.5l-0.1,0.1c-0.9,1-2.1,1.6-3.3,2c-4,1.4-6.7,5.2-6.7,9.4v1.5c0,0.8,0.6,1.4,1.4,1.4h3.2c0.8,0,1.6-0.6,1.6-1.5L28.2,35.1z" fill="#2563eb"/>
            </g>
        </svg>
    );
}

const FILTER_TABS = [
    { key: 'all', label: 'Todos' },
    { key: 'high', label: 'Alto' },
    { key: 'medium', label: 'Médio' },
    { key: 'low', label: 'Baixo' },
];

const SEV_LABEL = { high: 'Alto', medium: 'Médio', low: 'Baixo' };
const SEV_COLORS = {
    high:   { bg: '#fee2e2', color: '#dc2626' },
    medium: { bg: '#fef3c7', color: '#d97706' },
    low:    { bg: '#dbeafe', color: '#2563eb' },
};
const BADGE_COLORS = { high: '#dc2626', medium: '#d97706', low: '#2563eb' };

function SuspiciousApps({ detectedSuspiciousApps, installedApps }) {
    const [filter, setFilter] = useState('all');
    const [expanded, setExpanded] = useState(null);

    const installMap = buildInstallMap(installedApps);

    const ord = { high: 0, medium: 1, low: 2 };
    const allSusp = [...(detectedSuspiciousApps || [])].sort(
        (a, b) => (ord[a.risk] ?? 3) - (ord[b.risk] ?? 3)
    );
    const filtered = filter === 'all' ? allSusp : allSusp.filter(s => s.risk === filter);

    const topSev = allSusp.some(s => s.risk === 'high') ? 'high'
        : allSusp.some(s => s.risk === 'medium') ? 'medium'
        : allSusp.length > 0 ? 'low' : null;

    const toggle = (pkg) => setExpanded(prev => prev === pkg ? null : pkg);

    return (
        <div style={{ borderTop: '1px solid #e2e8f0', marginTop: '22px', paddingTop: '18px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap', marginBottom: '14px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 5.5C11.4477 5.5 11 5.94772 11 6.5V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V6.5C13 5.94772 12.5523 5.5 12 5.5Z" fill="#0b1f82"/>
                        <path d="M12 17.5C12.8284 17.5 13.5 16.8284 13.5 16C13.5 15.1716 12.8284 14.5 12 14.5C11.1716 14.5 10.5 15.1716 10.5 16C10.5 16.8284 11.1716 17.5 12 17.5Z" fill="#0b1f82"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M12 1.00195C11.0268 1.00195 10.3021 1.39456 9.68627 1.72824C9.54287 1.80594 9.40536 1.88044 9.27198 1.94605C8.49696 2.32729 7.32256 2.78014 4.93538 2.94144C3.36833 3.04732 1.97417 4.32298 2.03666 6.03782C2.13944 8.85853 2.46666 11.7444 3.12474 14.1763C3.76867 16.5559 4.78826 18.7274 6.44528 19.8321C8.02992 20.8885 9.33329 21.8042 10.2053 22.4293C11.276 23.1969 12.724 23.1969 13.7947 22.4293C14.6667 21.8042 15.97 20.8885 17.5547 19.8321C19.2117 18.7274 20.2313 16.5559 20.8752 14.1763C21.5333 11.7445 21.8605 8.8586 21.9633 6.03782C22.0258 4.32298 20.6316 3.04732 19.0646 2.94144C16.6774 2.78014 15.503 2.32729 14.728 1.94605C14.5946 1.88045 14.4571 1.80596 14.3138 1.72828C13.6979 1.39459 12.9732 1.00195 12 1.00195ZM5.07021 4.93689C7.70274 4.75901 9.13306 4.24326 10.1548 3.74068C10.4467 3.5971 10.6724 3.47746 10.8577 3.37923C11.3647 3.11045 11.5694 3.00195 12 3.00195C12.4305 3.00195 12.6352 3.11045 13.1423 3.37923C13.3276 3.47746 13.5533 3.5971 13.8452 3.74068C14.8669 4.24326 16.2972 4.75901 18.9298 4.93689C19.5668 4.97993 19.9826 5.47217 19.9646 5.965C19.865 8.70066 19.5487 11.4218 18.9447 13.6539C18.3265 15.9383 17.4653 17.4879 16.4453 18.1679C14.8385 19.2392 13.5162 20.1681 12.6294 20.8038C12.2553 21.072 11.7447 21.072 11.3705 20.8038C10.4837 20.1681 9.1615 19.2392 7.55469 18.1679C6.53465 17.4879 5.67349 15.9383 5.0553 13.6538C4.45127 11.4217 4.13502 8.70059 4.03533 5.965C4.01738 5.47217 4.43314 4.97993 5.07021 4.93689Z" fill="#0b1f82"/>
                    </svg>
                    <span style={{ fontFamily: '"Open Sans"', fontWeight: '700', fontSize: '15px', color: '#0b1f82' }}>Apps suspeitos</span>
                    {allSusp.length > 0 ? (
                        <span style={{ fontFamily: '"Open Sans"', fontWeight: '700', fontSize: '12px', lineHeight: '1', color: '#fff', background: BADGE_COLORS[topSev], padding: '5px 9px', borderRadius: '999px' }}>{allSusp.length}</span>
                    ) : (
                        <span style={{ fontFamily: '"Open Sans"', fontWeight: '600', fontSize: '12px', lineHeight: '1', color: '#1B7A30', background: '#dcfce7', padding: '5px 9px', borderRadius: '999px' }}>Limpo</span>
                    )}
                </div>
            </div>

            {allSusp.length > 0 ? (
                <>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '2px', background: '#f1f5f9', borderRadius: '8px', padding: '3px', width: 'fit-content', marginBottom: '12px' }}>
                        {FILTER_TABS.map(tab => (
                            <button
                                key={tab.key}
                                onClick={() => setFilter(tab.key)}
                                style={{
                                    border: 'none', cursor: 'pointer', padding: '7px 13px', borderRadius: '6px',
                                    fontFamily: '"Open Sans"',
                                    fontWeight: filter === tab.key ? '600' : '500',
                                    fontSize: '12px',
                                    background: filter === tab.key ? '#fff' : 'transparent',
                                    color: filter === tab.key ? '#0b1f82' : '#64748b',
                                    boxShadow: filter === tab.key ? '0 1px 2px rgba(0,0,0,0.1)' : 'none',
                                }}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {filtered.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            {filtered.map(item => {
                                const isExpanded = expanded === item.package_name;
                                const { bg: sevBg, color: sevColor } = SEV_COLORS[item.risk] || SEV_COLORS.low;
                                const installed = installMap.get(item.package_name);
                                return (
                                    <div
                                        key={item.package_name}
                                        onClick={() => toggle(item.package_name)}
                                        style={{ border: '1px solid #e2e8f0', borderRadius: '10px', padding: '12px 14px', cursor: 'pointer', background: '#fff' }}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                            <SevIcon sev={item.risk} />
                                            <div style={{ minWidth: '120px', flex: 1 }}>
                                                <div style={{ fontFamily: '"Open Sans"', fontWeight: '500', fontSize: '13px', lineHeight: '1.3', color: '#1e293b', wordBreak: 'break-all' }}>{item.package_name}</div>
                                                <div style={{ fontFamily: '"Open Sans"', fontSize: '12px', lineHeight: '1.3', color: '#64748b', marginTop: '2px' }}>
                                                    {item.name}{TYPE_LABELS[item.type] ? ` · ${TYPE_LABELS[item.type]}` : ''}
                                                </div>
                                            </div>
                                            <span style={{ fontFamily: '"Open Sans"', fontWeight: '600', fontSize: '11px', lineHeight: '1', color: sevColor, background: sevBg, padding: '5px 8px', borderRadius: '4px', whiteSpace: 'nowrap' }}>
                                                {SEV_LABEL[item.risk] || item.risk}
                                            </span>
                                            <svg width="19" height="19" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d={isExpanded ? 'M7 15l5-5 5 5' : 'M7 9l5 5 5-5'} stroke={isExpanded ? '#0b1f82' : '#94a3b8'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </div>
                                        {isExpanded && installed && (
                                            <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #e2e8f0', display: 'flex', gap: '40px', flexWrap: 'wrap' }}>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                                                    <span style={{ fontFamily: '"Open Sans"', fontWeight: '500', fontSize: '11px', letterSpacing: '.04em', textTransform: 'uppercase', color: '#94a3b8' }}>Primeira instalação</span>
                                                    <span style={{ fontFamily: '"Open Sans"', fontWeight: '600', fontSize: '13px', color: '#1e293b' }}>{formatAbsDate(installed.first_install_date)}</span>
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                                                    <span style={{ fontFamily: '"Open Sans"', fontWeight: '500', fontSize: '11px', letterSpacing: '.04em', textTransform: 'uppercase', color: '#94a3b8' }}>Última atualização</span>
                                                    <span style={{ fontFamily: '"Open Sans"', fontWeight: '600', fontSize: '13px', color: '#1e293b' }}>{formatAbsDate(installed.last_update_date)}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <div style={{ padding: '18px', textAlign: 'center', color: '#94a3b8', fontFamily: '"Open Sans"', fontSize: '13px', lineHeight: '1.4' }}>
                            Nenhum app suspeito neste nível de risco.
                        </div>
                    )}
                </>
            ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '14px 16px', background: '#dcfce7', borderRadius: '10px' }}>
                    <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flex: 'none' }}>
                        <path fillRule="evenodd" clipRule="evenodd" d="M8 16L4.35009 13.3929C2.24773 11.8912 1 9.46667 1 6.88306V3L8 0L15 3V6.88306C15 9.46667 13.7523 11.8912 11.6499 13.3929L8 16ZM12.2071 5.70711L10.7929 4.29289L7 8.08579L5.20711 6.29289L3.79289 7.70711L7 10.9142L12.2071 5.70711Z" fill="#1B7A30"/>
                    </svg>
                    <span style={{ fontFamily: '"Open Sans"', fontWeight: '500', fontSize: '14px', lineHeight: '1.4', color: '#1B7A30' }}>Nenhum app suspeito detectado.</span>
                </div>
            )}
        </div>
    );
}

export default SuspiciousApps;
